"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Table = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowUpward = _interopRequireDefault(require("@material-ui/icons/ArrowUpward"));

var _ArrowDownward = _interopRequireDefault(require("@material-ui/icons/ArrowDownward"));

var _styles = require("@material-ui/core/styles");

var _lodash = _interopRequireDefault(require("lodash"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)({
  table: {
    minWidth: 650
  },
  link: {
    color: '#624C92'
  },
  orderedCell: {
    '& span': {
      marginLeft: 4,
      marginTop: 2,
      transition: 'all .2s',
      position: 'absolute'
    },
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hide: {
    color: 'transparent'
  }
});

var Table = function Table(_ref) {
  var cells = _ref.cells,
      rows = _ref.rows,
      displayRowCheckbox = _ref.displayRowCheckbox,
      onCheckRows = _ref.onCheckRows,
      selectedRows = _ref.selectedRows,
      disableCheckAll = _ref.disableCheckAll;
  var classes = useStyles();

  var _useState = (0, _react.useState)(10),
      _useState2 = _slicedToArray(_useState, 2),
      rowsPerPage = _useState2[0],
      setRowsPerPage = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      page = _useState4[0],
      setPage = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      tableRows = _useState6[0],
      setTableRows = _useState6[1];

  var _useState7 = (0, _react.useState)('asc'),
      _useState8 = _slicedToArray(_useState7, 2),
      orderState = _useState8[0],
      setOrderState = _useState8[1];

  (0, _react.useEffect)(function () {
    var rowsPerPageStorage = localStorage.getItem('rowsPerPage');

    if (rowsPerPageStorage) {
      setRowsPerPage(rowsPerPageStorage);
    }
  }, []);
  (0, _react.useEffect)(function () {
    setTableRows(rows);
  }, [rows]);

  var renderSelectRow = function renderSelectRow(row) {
    if (!displayRowCheckbox) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: !!selectedRows.find(function (sr) {
        return sr.key === row.key;
      }),
      color: "primary",
      onChange: function onChange(evt) {
        if (evt.target.checked) {
          onCheckRows([].concat(_toConsumableArray(selectedRows), [row]));
        } else {
          onCheckRows(selectedRows.filter(function (sr) {
            return sr.key !== row.key;
          }));
        }
      }
    }));
  };

  var renderSelectAllRows = function renderSelectAllRows() {
    if (!displayRowCheckbox) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      padding: "checkbox"
    }, !disableCheckAll && /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      checked: tableRows && tableRows.length === selectedRows.length,
      color: "primary",
      onChange: function onChange(evt) {
        if (evt.target.checked) {
          onCheckRows(tableRows);
        } else {
          onCheckRows([]);
        }
      }
    }));
  };

  var renderCellValue = function renderCellValue(row, column) {
    var value = row[column];
    var redirectTo = row.redirectTo;

    if (redirectTo && redirectTo.fromColumn === column) {
      return /*#__PURE__*/_react.default.createElement("a", {
        href: redirectTo.path,
        className: classes.link
      }, value);
    }

    return value;
  };

  var orderBy = function orderBy(param) {
    if (orderState === 'asc') {
      setTableRows(_lodash.default.sortBy(tableRows, param));
      setOrderState('desc');
    }

    if (orderState === 'desc') {
      setTableRows(_lodash.default.sortBy(tableRows, param).reverse());
      setOrderState('default');
    }

    if (orderState === 'default') {
      setTableRows(rows);
      setOrderState('asc');
    }
  };

  var handleArrows = function handleArrows() {
    if (orderState === 'asc') {
      return /*#__PURE__*/_react.default.createElement(_ArrowUpward.default, {
        fontSize: "small"
      });
    }

    if (orderState === 'desc') {
      return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, {
        fontSize: "small"
      });
    }

    return /*#__PURE__*/_react.default.createElement(_ArrowDownward.default, {
      className: classes.hide,
      fontSize: "small"
    });
  };

  return /*#__PURE__*/_react.default.createElement(_core.TableContainer, {
    component: _core.Paper
  }, /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: classes.table
  }, /*#__PURE__*/_react.default.createElement(_core.TableHead, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, renderSelectAllRows(), cells.map(function (cell, index) {
    return cell.order ? /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      className: classes.orderedCell,
      key: "cell-".concat(index),
      component: "th",
      onClick: function onClick() {
        return orderBy(cell.code);
      }
    }, cell.name, /*#__PURE__*/_react.default.createElement("span", null, handleArrows())) : /*#__PURE__*/_react.default.createElement(_core.TableCell, {
      key: "cell-".concat(index),
      component: "th"
    }, cell);
  }))), /*#__PURE__*/_react.default.createElement(_core.TableBody, null, tableRows && (rowsPerPage > 0 ? tableRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : tableRows).map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_core.TableRow, {
      key: "tr-".concat(row.key),
      selected: displayRowCheckbox && !!selectedRows.find(function (sr) {
        return sr.key === row.key;
      }),
      hover: true,
      className: row.className
    }, renderSelectRow(row), Object.keys(row).filter(function (column) {
      return !['key', 'redirectTo', 'className'].includes(column);
    }).map(function (column, index) {
      return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
        key: "td-".concat(index),
        component: "td",
        scope: "row"
      }, renderCellValue(row, column));
    }));
  })), /*#__PURE__*/_react.default.createElement(_core.TableFooter, null, /*#__PURE__*/_react.default.createElement(_core.TableRow, null, /*#__PURE__*/_react.default.createElement(_core.TablePagination, {
    rowsPerPageOptions: [10, 50, 100],
    colSpan: cells.length + 1,
    count: tableRows && tableRows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onChangePage: function onChangePage(evt, newPage) {
      return setPage(newPage);
    },
    onChangeRowsPerPage: function onChangeRowsPerPage(evt) {
      localStorage.setItem('rowsPerPage', evt.target.value);
      setRowsPerPage(evt.target.value);
    }
  })))));
};

exports.Table = Table;
Table.defaultProps = {
  displayRowCheckbox: false,
  onCheckRows: null,
  selectedRows: null,
  disableCheckAll: false
};
Table.propTypes = {
  /**
   * Array de objetos com os dados que deve conter em cada linha da tabela
   */
  rows: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,

  /**
   * Array de strings que contém o nome das colunas da tabela
   */
  cells: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   * Exibir ou ocultar o checkbox de seleção de linhas
   */
  displayRowCheckbox: _propTypes.default.bool,

  /**
  /**
   * Exibir ou ocultar o checkbox de seleção de linhas
   */
  disableCheckAll: _propTypes.default.bool,

  /**
   * Função disparada no momento que uma ou mais linhas são seleciondas
   */
  onCheckRows: _propTypes.default.func,

  /**
   * Array de objetos com as linhas que foram seleciondas
   */
  selectedRows: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = Table;
exports.default = _default;